// Benji widget entry point. The WP plugin enqueues this bundle and we mount
// into a #ccb-benji-root element we own. If the host page doesn't have one,
// we create it ourselves so the plugin doesn't need to inject markup.

import { render } from "preact";
import { BenjiApp } from "./BenjiApp";
import styles from "./styles.css";

function injectStyles() {
  if (document.getElementById("ccb-benji-styles")) return;
  const tag = document.createElement("style");
  tag.id = "ccb-benji-styles";
  tag.textContent = styles as unknown as string;
  document.head.appendChild(tag);
}

function ensureRoot(): HTMLElement {
  let root = document.getElementById("ccb-benji-root") as HTMLElement | null;
  if (!root) {
    root = document.createElement("div");
    root.id = "ccb-benji-root";
    document.body.appendChild(root);
  }
  return root;
}

function mount() {
  injectStyles();
  const root = ensureRoot();
  render(<BenjiApp />, root);
}

// Defer to DOM-ready so we don't try to read document.body too early.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount, { once: true });
} else {
  mount();
}
